import filesize from 'filesize'

export default {
    filesize: filesize,
};


